import { Actions } from './audit-logs.actions'
import { fromJS } from 'immutable'
import * as auditLogsTypes from './audit-logs.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    filters: [],
    pagination: {
      page: 1,
      page_size: 20,
      // order_by: 'createdAt',
      // sort: 'desc',
    },
    total: 0,
    filtered: 0,
  },
  info: {
    isLoading: false,
    data: [],
  },
  export: {
    isLoading: false,
  },
})

export function auditLogsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case auditLogsTypes.FETCH_AUDIT_LOGS_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case auditLogsTypes.FETCH_AUDIT_LOGS_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'filtered'], fromJS(action.filtered))
    }

    case auditLogsTypes.FETCH_AUDIT_LOGS_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case auditLogsTypes.FETCH_AUDIT_LOG_INFO_REQUEST: {
      return state.setIn(['info', 'isLoading'], true)
    }

    case auditLogsTypes.FETCH_AUDIT_LOG_INFO_SUCCESS: {
      return state
        .setIn(['info', 'isLoading'], false)
        .setIn(['info', 'data'], fromJS(action.payload))
    }

    case auditLogsTypes.FETCH_AUDIT_LOG_INFO_FAILURE: {
      return state.setIn(['info', 'isLoading'], false)
    }

    case auditLogsTypes.EXPORT_AUDIT_LOGS_REQUEST: {
      return state.setIn(['export', 'isLoading'], true)
    }

    case auditLogsTypes.EXPORT_AUDIT_LOGS_SUCCESS: {
      return state.setIn(['export', 'isLoading'], false)
    }

    case auditLogsTypes.EXPORT_AUDIT_LOGS_FAILURE: {
      return state.setIn(['export', 'isLoading'], false)
    }

    case auditLogsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case auditLogsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
